import { Box } from "@mui/material";

import styles from "./ActivePointIndicator.module.css";
import { TimestampedLocation } from "./geoTypes";

interface ActivePointIndicatorProps {
  activeLocation: TimestampedLocation | null;
}

export function ActivePointIndicator({
  activeLocation,
}: ActivePointIndicatorProps) {
  if (!activeLocation) {
    return null;
  }

  return (
    <Box
      className={styles.legend}
      sx={{
        display: {
          xs: "none",
          sm: "block",
        },
      }}
    >
      <>
        Current: {activeLocation.latitude.toFixed(6)} |{" "}
        {activeLocation.longitude.toFixed(6)}
      </>
    </Box>
  );
}
